// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-fa02819b","button":"button-d5174705","primary":"primary-d8266ead"};